module.exports = __webpack_public_path__ + "static/media/Small multiple violations of the 10.53ab3092.png";